import React, { useState} from 'react'
import { APIINTEGRACION } from '../../helpers/url';
import useWindowDimensions from "../../helpers/useWindowDimensions";
import { Excedente } from "../../assets/icons/dashboard";
import { Card, Row, Col, Table } from 'react-bootstrap';
import CardResumenPago from '../cards/CardResumenPago';
import ButtonProgreso from '../buttons/Button'
import { useLocation } from 'react-router-dom';
import { format } from 'date-fns';
import NumberFormat from 'react-number-format';
import Loading from '../loading/Loading';
import { api } from "../../helpers/api";
import Header from '../header/Header';


function VentaExitosa() {
    const { state } = useLocation();
    const { width } = useWindowDimensions();
    const [showLoading, setShowLoading] = useState({ display: 'none' });

    const icons = {
        cuotas: <Excedente />
    }
    const container = {
        // borderRightWidth: "50px",
        // borderRightColor: "black",
        // borderRightStyle: "solid",
        width: "100%",
        display: "flex",
        justifyContent: "center",
    };
    const fecha = new Date(state.fecha);
    fecha.setDate(fecha.getDate() + 1);
    const fecha_pago = format(fecha, "dd-MM-yyyy");
    const redirectBandeja = async()=>{
        setShowLoading({ display: "block" });
        const { data } = await api.post(APIINTEGRACION.POST.REDIRECT+state.w);
        setShowLoading({ display: "none" });
        window.location.href = data.data;
      }
    return (
        <>
        <section style={{ width: "100%" }}>
        <Header />
        <div style={container}>
        <Loading estilo={showLoading}></Loading>
        <Row
            className="mt-4"
            style={{ width: width >= 701 ? "87%" : "100%" }}
            >
            <Col>
                <Card>
                    <Card.Body>
                        <CardResumenPago
                            icon={icons.cuotas}
                            title='Resumen de Pagos'
                            progress={100}
                            btnBack={false}
                            volverInicio={
                                <ButtonProgreso
                                    className='noprint'
                                    sizeText={1}
                                    onClick={redirectBandeja}
                                    >
                                    Volver al Inicio
                                </ButtonProgreso>
}>
                            <div className='d-flex flex-column my-2 w-75 align-items-center'>
                                <div style={{ background: "rgb(253, 209, 53)", borderColor: "rgb(253, 209, 53)", borderRadius: "15px", padding: '20px' }}>
                                    Su pago ha sido realizado con éxito, hemos enviado su comprobante de pago al correo informado.
                                </div>
                                <div className={`${width >= 701 ? "w-75" : "w-90"} mt-4`}>
                                    <Table striped>
                                        <thead>
                                            <tr style={{ backgroundColor: "rgb(253, 209, 53)" }}>
                                                <th scope='col' colSpan={2}>Detalle de orden de Pago</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <th scope='row'>Rut del Cliente</th>
                                                <td style={{ textAlign: "center" }}>{state.rut}</td>
                                            </tr>
                                            <tr>
                                                <th scope='row'>Nombre Comercio</th>
                                                <td style={{ wordBreak: "break-all", textAlign: "center" }}>{state.nombre}</td>
                                            </tr>
                                            <tr>
                                                <th scope='row'>Número de Orden</th>
                                                <td style={{ textAlign: "center" }}>{state.orden}</td>
                                            </tr>
                                            <tr>
                                                <th scope='row'>Monto (Peso Chilenos) $</th>
                                                <td style={{ textAlign: "center" }}><NumberFormat
                                                    value={Number(state.monto)}
                                                    displayType='text'
                                                    prefix="$"
                                                    thousandSeparator="."
                                                    decimalScale={2}
                                                    decimalSeparator=","
                                                /></td>
                                            </tr>
                                            <tr>
                                                <th scope='row'>Fecha de transacción</th>
                                                <td style={{ textAlign: "center" }}>{fecha_pago}</td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>
                            </div>
                        </CardResumenPago>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
        </div>
        </section>
    </>
    )
}

export default VentaExitosa